/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: "ap-southeast-1",
    aws_appsync_graphqlEndpoint: "https://sm7gc6gbnfb3njvljkk6myidvi.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    aws_appsync_region: "ap-southeast-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_appsync_apiKey: "da2-z6kdelevancqxbfaqzontaugre",
    aws_cognito_identity_pool_id: "ap-southeast-1:dc0d515a-2d30-4c10-8f72-416892e6d802",
    aws_cognito_region: "ap-southeast-1",
    aws_user_pools_id: "ap-southeast-1_mA5l5rZXJ",
    aws_user_pools_web_client_id: "tgur11qb6bglgnaugv30je3h2",
    oauth: {
            domain: "denali-apstg.auth.ap-southeast-1.amazoncognito.com",
            scope: ["openid", "profile", "aws.cognito.signin.user.admin"],
            redirectSignIn: window.location.origin,
            redirectSignOut: `https://corpextdev.b2clogin.com/corpextdev.onmicrosoft.com/B2C_1A_OIDC_USERINFO_DENALI/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
            responseType: "code",
            client_id: "522f643d-5757-4085-b88d-c23004a8f0dd"
    },
    aws_cognito_username_attributes: ["EMAIL"],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: ["EMAIL","NAME"],
    aws_cognito_mfa_configuration: "OFF",
    aws_cognito_mfa_types: ["SMS"],

    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: []
    },
    aws_cognito_verification_mechanisms: ["EMAIL"],
    aws_user_files_s3_bucket: "denali-analytics-validation-storage155607-apstg",
    aws_user_files_s3_bucket_region: "ap-southeast-1",
    language: "it",
    appEnvironment: {
        BUILD_ENV: "apstg",
        DEFAULT_SUBCRIBER_FOR_BUILDING: "vsi-test@service.traneconnect.com",
        DEFAULT_BUILDING_IMAGE_URL: "https://denali-image-data-b3uzhfippvbzfcj6bdzkoqlwha-apstg.s3.amazonaws.com/building/default/default_facility.jpg",
        externalLinks: {
        traneConnectBaseURL: "https://stg.connect.tis.trane.asia",
        commandCenterBaseURL: "https://stg.tcc.tis.trane.asia",
        commandCenterGen4BaseURL: "https://gen4.tcc.tis-stg.trane.com/"
        }
    },
    predictions: {
        convert: {
            translateText: {
                region: "ap-southeast-1",
                proxy: false,
                defaults: {
                    sourceLanguage: "en",
                    targetLanguage: "fr"
                }
            },
      speechGenerator: {
        region: "ap-southeast-1",
        proxy: false,
        defaults: {
          VoiceId: "Ivy",
          LanguageCode: "en-US"
        }
      },
      transcription: {
        region: "ap-southeast-1",
        proxy: false,
        defaults: {
          language: "en-US"
        }
      }
    },
    identify: {
      identifyText: {
        proxy: false,
        region: "ap-southeast-1",
        defaults: {
          format: "PLAIN"
        }
      },
      identifyEntities: {
        proxy: false,
        region: "ap-southeast-1",
        celebrityDetectionEnabled: true,
        defaults: {
          collectionId: "identifyEntities8b89c648-test",
          maxEntities: 50
        }
      },
      identifyLabels: {
        proxy: false,
        region: "ap-southeast-1",
        defaults: {
          type: "LABELS"
        }
      }
    },
    interpret: {
      interpretText: {
        region: "ap-southeast-1",
        proxy: false,
        defaults: {
          type: "ALL"
        }
      }
    }
    },

    "geo": {
        "amazon_location_service": {
            "region": "ap-southeast-1",
            "search_indices": {
                "items": [
                    "denalilocator-apstg"
                ],
                "default": "denalilocator-apstg"
            },
            "maps": {
                "items": {
                    "denalimap-apstg": {
                        "style": "VectorEsriNavigation"
                    }
                },
                "default": "denalimap-apstg"
            }
        }
    }
};


export const amplitudeKey = ""//"4fa65a8fddd9d2d8b07d1d2724b68b4d"
export default awsmobile
export const signOutUrl = `https://${awsmobile.oauth.domain}/logout?client_id=${awsmobile.aws_user_pools_web_client_id}&logout_uri=${awsmobile.oauth.redirectSignOut}&redirect_uri=${window.location.origin}&response_type=code`
export const APP_ID = "9b308188-33ad-4a84-8974-a412dc03e3f6"
export const remoteAccessURL = 'https://stg.api.tis.trane.asia/remoteaccess/connect'
export const openVPNURL = 'https://api.tis-stg.trane.asia/v2/remote'
export const staticFilesPath = "https://denali-staticfiles-b3uzhfippvbzfcj6bdzkoqlwha-apstg.s3.amazonaws.com"
export const zendeskWidgetKey = "f42546cb-115b-4d5d-bf44-b4ddab8f10cd"
export const responsiveControlAPIURL = 'https://api.tis.trane.com/rc'
export const REACT_APP_API_ENDPOINT ="https://g9v0inu094.execute-api.us-east-1.amazonaws.com/dev/generate"
export const llmClientId = "pD6dOZoWO92F3MG0LIh5n8YtpivrdeIn7XWrc4Bw"
export const aiChatWebSocketURL="wss://zkimqfwv9l.execute-api.ap-southeast-1.amazonaws.com/apstg/"
